export class NotificationSubGroup {
    public notificationSubGroupId: number;
    public notificationId: number;
    public subGroupId: number; 
}